import mitt from 'mitt';

export enum Events {
  SERVICE_ERROR = 'SERVICE_ERROR'
}

export default mitt();
